import './dashboard.scss';
import Tab from '../compentent/tab/tab';
import { useEffect, useRef, useState } from 'react';
import { Input} from 'antd';
import '../../commonStyle/table.scss';
import ModelView from './model/model';
import  modelContentData  from './data/modelContentData';
import useDashboard from '../../../base/hooks/appointmentManagement/dashboard/useDashboard';
import OrderModel from '../../../base/models/appointmentManagement/dashboard/dashboardModel';
import PaginationView from '../../commonViews/PaginationView';
import type { DatePickerProps } from 'antd';
import { DatePicker, Space } from 'antd';
import moment from 'moment';
import { message } from 'antd';
import AllTablePc from './table/allTable/allTablePc';
import AllTableMobile from './table/allTable/allTableMobile';
import dayjs from 'dayjs';
import { LeftOutlined, RightOutlined } from '@ant-design/icons';
import useSecurityOrderSse from '../../../base/hooks/appointmentManagement/dashboard/useSecurityOrderSse';
// 适配移动端
import '../../phone/appointmentManagement/dashboard/dashboard.scss';
interface TabItem {
    id: number | string;
    name: string;
    time?: string;
    hidden?: boolean;
}
interface list {
    title: string;
    info: string;
}
interface infoList {
    allTitle: string;
    img: string;
    list: list[];
}
interface ModelTitle {
    title: string;
    desc: string;
}
interface ModelContentData {
    info: infoList[];
    modelTitle: ModelTitle;
}
const Dashboard = () => {
    const [messageApi, contextHolder] = message.useMessage();
    const { getOrderList, verifyOrder } = useDashboard();
    const tabList: TabItem[] = [
        {
            id: '',
            name: 'All',
        },
        {
            id: 2,
            name: 'Meeting Room',
            hidden: true,
        },
        {
            id: 1,
            name: 'Lounge',
        },
        {
            id: 3,
            name: 'Safe Box',
        },
    ]
    const [appointTypeList, setAppointTypeList] = useState<TabItem[]>([
        
    ]);
    const [orderNo, setOrderNo] = useState('');
    const [activeTab, setActiveTab] = useState<number | string>('');
    const [appointType, setAppointType] = useState<number | string>(1);
    const [dataList, setDataList] = useState<OrderModel[]>([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPage, setTotalPage] = useState(0);
    const [total, setTotal] = useState(0);
    const [loading, setLoading] = useState(false);
    const [loadingMore, setLoadingMore] = useState(false);
    const [isShowModel, setIsShowModel] = useState(false);
    const [isVerifying, setIsVerifying] = useState(false);
    const [info, setInfo] = useState<any[]>([]);
    const [dayType, setDayType] = useState('today');
    const [modelTitle, setModelTitle] = useState({
        title:'',
        desc:'',
    });
    const [selectedItem, setSelectedItem] = useState<OrderModel | null>(null);
    const [isMobile, setIsMobile] = useState(false);
    const [isPhone, setIsPhone] = useState(false);
    const dashboardScrollRef = useRef<HTMLDivElement>(null);
    const [selectTime,setSelectTime] = useState<string>('')
    const dateFormat = 'YYYY/MM/DD';
    const [isFristEnter,setIsFristEnter] = useState(true)
    const [expiredTime,setExpiredTime] = useState<string>('')
    useEffect(() => {
        setAppointTypeList([
            {
                id:1,
                name: 'Booking Order',
            },
            {
                id: 2,
                name: 'No-Show',
            },
            {
                id: 3,
                name: 'Cancelled',
            },
            {
                id: 5,
                name: 'Completed',
            },
        ]);
        if(isFristEnter){//首次进入
            setSelectTime('');
            getOrderListData(1, '',1, '', '');
        }
    }, []);
    useEffect(() => {
        if(!isFristEnter && !isPhone){
            if(appointType === 2){
                getOrderListData(currentPage, activeTab, 2, orderNo, expiredTime);
            }else{
                getOrderListData(currentPage, activeTab, appointType, orderNo, selectTime);
            }
        }
    }, [currentPage, isPhone]);
    // 切换tab
    const resetListScroll = () => {
        const dashboardElement = dashboardScrollRef.current;
        if (!dashboardElement) {
            return;
        }
        const scrollContainer = isPhone
            ? dashboardElement
            : dashboardElement.closest('.all-content');
        scrollContainer?.scrollTo({
            top: 0,
            behavior: 'auto'
        });
    };
    const getActiveTab = (id: number | string,type: string) => {
        resetListScroll();
        if(type === 'line'){//切换类型
            setActiveTab(id);
            setCurrentPage(1);
            if(appointType === 2){
                getOrderListData(1, id, 2, orderNo, expiredTime);
            }else{
                // console.log(appointType)
                getOrderListData(1, id, appointType, orderNo, selectTime);
            }
        }else if(type === 'box'){//切换类型是否过期和时间
            const retainedTime = appointType === 2 ? expiredTime : selectTime;
            setAppointType(id);
            setCurrentPage(1);
            if(id === 2){
                setExpiredTime(retainedTime)
                getOrderListData(1,activeTab,2, orderNo, retainedTime);
            }else{
                setSelectTime(retainedTime)
                getOrderListData(1,activeTab,id, orderNo, retainedTime);
            }
        }
    }
    //不同的产品类型获取不同的弹窗内容
    useEffect(() => {
        let tabNum = 0;
        if(activeTab){
            tabNum = activeTab as number;
        }
        const { info, modelTitle } = modelContentData(activeTab as number) as { info: any[], modelTitle: { title: string, desc: string } };
        setInfo(info);
        setModelTitle(modelTitle);
    }, [activeTab]);
    // 搜索
    const handleSearch = () => {
        resetListScroll();
        setCurrentPage(1);
        if(appointType === 2){
            getOrderListData(1, activeTab, 2, orderNo, expiredTime);
        }else{
            getOrderListData(1, activeTab, appointType, orderNo, selectTime);
        }
    }
    const onChange: DatePickerProps['onChange'] = (date:any, dateString:any) => {
        resetListScroll();
        setCurrentPage(1)
        if (dateString) {
            if(appointType === 2){//已过期
                setExpiredTime(dateString)
                setSelectTime('')
                getOrderListData(1, activeTab, 2, orderNo, dateString);
            }else{
                setExpiredTime('')
                setSelectTime(dateString)
                getOrderListData(1, activeTab, appointType, orderNo, dateString);
            }
        }else{
            if(appointType === 2){
                setExpiredTime('')
                setSelectTime('')
                getOrderListData(1, activeTab, 2, orderNo, '');
            }else{
                setExpiredTime('')
                setSelectTime('')
                getOrderListData(1, activeTab, appointType, orderNo, '');
            }
        }
    };
    const getDateEvent = (type:number) => {
        resetListScroll();
        // appointType只有1才有
        let changeDate = ''
        if(type === 1){//当前选择的时间减一天
            changeDate = dayjs(selectTime).subtract(1, 'day').format(dateFormat)
            setSelectTime(changeDate)

        }else if(type === 2){//当前的时间家一天
            changeDate = dayjs(selectTime).add(1, 'day').format(dateFormat)
            setSelectTime(changeDate)
        }
        getOrderListData(1, activeTab, appointType, orderNo, changeDate);
    }
    const getModelInfo = (item: OrderModel) => {
        console.log(item,2222)
        const { info, modelTitle } = modelContentData(item.resource_type) as { info: infoList[], modelTitle: { title: string, desc: string } };
        let infoNew = info
        infoNew[0].list[0].info = item.contact_mobile ? item.contact_mobile : '-';
        infoNew[0].list[1].info = item.appointment_code ? item.appointment_code : '-';
        infoNew[0].list[2].info = item.appointment_name ? item.appointment_name : '-';
        infoNew[1].list[0].info = item.booking_date ? item.booking_date : '-';
        infoNew[1].list[1].info = item.start_time && item.end_time ? `${item.start_time} - ${item.end_time}` : '-';
        infoNew[1].list[2].info = item.visitor_count ? item.visitor_count : '-';
        setModelTitle(modelTitle)
        setInfo(infoNew)
        setSelectedItem(item);
        if(item.status === 1 || item.status === 4){//确认进入
            setIsShowModel(true);
        }else if(item.status === 2){//确认离开
            verifyOrderData(item)
        }
    }
    // 获取订单列表
    const getOrderListData = async (
        page: number,
        resourceType: number | string,
        statusNum: number | string,
        orderNoInfo: string,
        bookingDate: string,
        isLoadMore: boolean = false,
    ) => {
        if(isLoadMore){
            setLoadingMore(true);
        }else{
            setLoading(true);
        }
        let searchDay = '';
        let searchStatus: number | string = 1;
        if(statusNum === 3){
            searchDay = bookingDate;
            searchStatus = 3;
        }if(statusNum === 5){
            searchDay = bookingDate;
            searchStatus = 5;
        }
        if(statusNum === 1){//今天
            searchDay = bookingDate;
            searchStatus = '1,2,4'
        }if(statusNum === 2){//已过期
            if(bookingDate){//已过期时间查询
                searchDay = bookingDate;
                searchStatus = 4;
            }else{
                searchDay = '';
                searchStatus = 4;
            }
        }
        const res = await getOrderList({
            page: page,
            pageSize: 10,
            resource_type:resourceType,//资源类型
            status:searchStatus,//订单状态订单状态：1-已支付(待核销)，2-已完成，3-已取消，4-爽约
            vague_field: orderNoInfo,//模糊搜索
            booking_date:searchDay,//时间查询
        });
        if(res.list.length > 0) {
            if(isLoadMore && page > 1){
                setDataList((prevList) => [...prevList, ...res.list]);
            }else{
                setDataList(res.list);
            }
            setTotalPage(res.totalPage);
            setTotal(res.total);
            setCurrentPage(page);
        }else{
            if(!isLoadMore || page === 1){
                setDataList([]);
            }
            setTotalPage(0);
            setTotal(0);
            setCurrentPage(page);
        }
        setIsFristEnter(false)
        setLoading(false);
        setLoadingMore(false);
    }
    const loadMore = () => {
        if(loading || loadingMore || currentPage >= totalPage){
            return;
        }
        const nextPage = currentPage + 1;
        if(appointType === 2){
            getOrderListData(nextPage, activeTab, 2, orderNo, expiredTime, true);
        }else{
            getOrderListData(nextPage, activeTab, appointType, orderNo, selectTime, true);
        }
    }
    const onRefresh = async () => {
        if(loading){
            return;
        }
        setCurrentPage(1);
        if(appointType === 2){
            await getOrderListData(1, activeTab, 2, orderNo, expiredTime);
        }else{
            await getOrderListData(1, activeTab, appointType, orderNo, selectTime);
        }
    }
    // 安保核销sse
    useSecurityOrderSse(onRefresh);

    const verifyOrderData = async (info:OrderModel) => {
        if(!info){
            messageApi.error('Please select an order');
            return;
        }
        if(isVerifying){
            return;
        }
        setIsVerifying(true);
        try {
        const res = await verifyOrder({
            order_sn: info.order_sn,
        });
        if(res.success){
            if(info.status === 1 || info.status === 4){//确认进入
                messageApi.success('Check in successfully');
            }else if(info.status === 2){//确认离开
                messageApi.success('Check out successfully');
            }
            setIsShowModel(false)
            setCurrentPage(1);
            if(appointType === 2){
                await getOrderListData(1, activeTab, 2, orderNo, expiredTime);
            }else{
                await getOrderListData(1, activeTab, appointType, orderNo, selectTime);
            }
        }else{
            messageApi.error(res.message);
        }
        } finally {
            setIsVerifying(false);
        }
    }
    useEffect(() => {
        // 根据正则是否是手机平板
        const isPhone = /Android|iPhone|iPad|iPod|BlackBerry|Windows Phone/i.test(navigator.userAgent);
        if (isPhone) {
            setIsPhone(true);
        }else{
            setIsPhone(false);
        }
        const handleResize = () => {
            if(window.innerWidth < 1024){
                setIsMobile(true);
            }else{
                setIsMobile(false);
            }
        }
        if(window.innerWidth < 1024){
            setIsMobile(true);
        }else{
            setIsMobile(false);
        }
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);
    const contentItem = () => {
        return (
            <div className='all-model-info'>
                {
                    info.map((item) => {
                        return (
                            <div className='content-item'>
                                <div className='content-item-title'>
                                    <img src={item.img} alt="title" />
                                    <div className='content-item-title-text'>{item.allTitle}</div>
                                </div>
                                {
                                    item.list.map((items:any) => {
                                        return (
                                            <div
                                                className='content-item-content-item'
                                                hidden={items.title === 'Visitors'}
                                            >
                                                <div className='content-item-content-item-title'>{items.title}</div>
                                                <div className='content-item-content-item-info'>{items.info}</div>
                                            </div>
                                        )
                                    })
                                }
                            </div>
                        )
                    })
                }
            </div>
        )
    }
    const showCardList = isPhone || isMobile;

    return (
        <div
            ref={dashboardScrollRef}
            id={isPhone ? 'dashboardScrollable' : undefined}
            className={`dashboard-main ${isPhone ? 'dashboard-main-phone' : ''} ${!isPhone && isMobile ? 'dashboard-main-card-pc' : ''}`}
        >
                <div className="table-content">
                <div className="dashboard-filter-sticky">
                    <div className={`filter-box ${appointType === 2 ? 'filter-box-show-data' : ''}`}>
                    <Tab tabList={appointTypeList as TabItem[]} 
                        type="box"
                        defaultActiveTab={1} 
                        getActiveTab={getActiveTab}/>
                        <div className="all-left-filter-box">
                            <div className="timer">
                                {(appointType === 1 && selectTime) && 
                                    <div className="time-left" onClick={() => getDateEvent(1)}>
                                        <LeftOutlined style={{ fontSize: '20px', color: '#898991' }} />
                                    </div>
                                }
                                {
                                    [1, 2, 3, 5].includes(Number(appointType)) && <DatePicker
                                    // 不默认选择日期
                                    value={appointType === 2 ?
                                    expiredTime ? dayjs(expiredTime, dateFormat) : null
                                    : selectTime ? dayjs(selectTime, dateFormat) : null
                                }
                                    onChange={onChange} 
                                    />
                                }
                                {(appointType === 1 && selectTime) && 
                                    <div className="time-right" onClick={() => getDateEvent(2)}>
                                        <RightOutlined style={{ fontSize: '20px', color: '#898991' }} />
                                    </div>
                                }
                            </div>
                            {/* <div className="export-btn">Export</div> */}
                        </div>
                </div>
                <div className={`filter-info`}>
                    <Tab tabList={tabList} 
                    type="line"
                    defaultActiveTab={''} 
                    getActiveTab={getActiveTab}/>
                    <div className={`input-container show-filter`}><Input 
                        value={orderNo}
                        onChange={(event) => setOrderNo(event.target.value)}
                            className='custom-input'  style={{
                                borderColor: '#fff',
                                boxShadow: 'none',
                                backgroundColor: '#fff',
                                fontSize: '14px',
                                height:'100%',
                                borderRadius:'100px'
                            }}
                        onPressEnter={(event) => handleSearch()}
                        placeholder="Search for phone number here"
                        prefix={<img src={require('../../../assets/appointmentManagement/dashboard/search.png')} alt="prefix" style={{ width: '22px', height: '22px' }} />} />
                    </div>
                </div>
                </div>
                <div className="title">Customer Reservation Slip</div>
                {
                    showCardList ? (
                        <AllTableMobile
                            dataList={dataList}
                            getModelInfo={getModelInfo}
                            appointType={appointType}
                            useInfiniteScroll={isPhone}
                            loadMore={loadMore}
                            onRefresh={onRefresh}
                            hasMore={currentPage < totalPage}
                            loading={loading}
                            loadingMore={loadingMore}
                            total={total}
                        />
                    ) : (
                        <AllTablePc
                            dataList={dataList}
                            getModelInfo={getModelInfo}
                            appointType={appointType}
                            loading={loading}
                        />
                    )
                }
                </div>
                {!isPhone && (
                    <div className={isMobile ? 'pagination-sticky-bottom' : ''}>
                        <PaginationView
                            currentPage={currentPage}
                            totalPage={totalPage}
                            onNext={() => { setCurrentPage(currentPage + 1) }}
                            onPrevious={() => { setCurrentPage(currentPage - 1) }}
                            onFoucsPage={(select) => {
                                window.scrollTo({
                                    top: 0,
                                    behavior: 'smooth'
                                });
                                setCurrentPage(select);
                            }}
                        />
                    </div>
                )}
            {isShowModel && selectedItem && <ModelView 
                    onBack={()=>{}}
                    onClose={()=>{
                        setIsShowModel(false);
                    }}
                    onConfirm={()=>{
                        verifyOrderData(selectedItem)
                    }}
                    isConfirming={isVerifying}
                    contentItem={contentItem()}
                    btnInfo={'Check in'}
                    modelTitle={modelTitle}
                />
            }
            {contextHolder}
        </div>
    )
}

export default Dashboard;
